// Core
import { useState } from "react";
import { useTranslation } from "react-i18next";

// Components
import { Crumbs, DateRangePopover, PageHead, SideTabs } from "components/AtomsV2";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";

// Pages
import Settlement from "pages/ReadSettlement/Settlement";
import BillingGuide from "pages/ReadSettlement/BillingGuide";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { selectTimeSelector, updateTimeSelector } from "state/application/applicationSlice";

function ReadSettlement() {
  const dispatch = useDispatch();
  const community = useSelector(selectCurrentCommunity);
  const { startDate, endDate, horizon, isExpanded } = useSelector(selectTimeSelector);
  const { t } = useTranslation(["settlement"]);

  const [side, setSide] = useState("settlement");

  const sideTabs = [
    { id: "settlement", icon: "query_stats", label: t("page.title") },
    { id: "files", icon: "receipt_long", label: t("page.tabs.files") },
  ];

  return (
    <div>
      <HelpFloatingButtonV2 helpScreen="settlement" />
      <Crumbs items={[{ label: community?.name || "—" }, { label: t("page.title") }]} />
      <PageHead
        title={t("page.title")}
        subtitle={t("page.subtitle")}
        actions={
          <DateRangePopover
            value={{ start: startDate, end: endDate }}
            onChange={(v) =>
              dispatch(
                updateTimeSelector({ startDate: v.start, endDate: v.end, horizon, isExpanded })
              )
            }
          />
        }
      />

      <SideTabs items={sideTabs} active={side} onChange={setSide}>
        {side === "settlement" && <Settlement />}
        {side === "files" && <BillingGuide />}
      </SideTabs>
    </div>
  );
}

export default ReadSettlement;
